import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => (
    <div className="sam__possibility section__padding" id="possibility">
        <div className="sam__possibility-image">
            <img src={possibilityImage} alt="possibility" />
        </div>
        <div className="sam__possibility-content" dir='rtl'>
            <h4>روش کار توسعه فناوران رایا</h4>
            <h1 className="gradient__text">صفر تا صد توسعه کسب و کار خود را با خیال راحت به ما بسپارید.</h1>
            <p>مشاورین شرکت توسعه فناوران رایا همواره در تلاش هستند تا با بررسی تخصصی کسب و کار شما بهترین روش ها و راه کار هارا به شما پیشنهاد دهند.</p>
            <h4><a href='#footer'>برای ارتباط با ما کلیک کنید.</a></h4>
        </div>
    </div>
);

export default Possibility;
